// Auto-generated SQL Components Map
import SQLs_Alter_Table from "./sql_all_components_complete/SQLs_Alter_Table.jsx";
import SQLs_And from "./sql_all_components_complete/SQLs_And.jsx";
import SQLs_Auto_Increment from "./sql_all_components_complete/SQLs_Auto_Increment.jsx";
import SQLs_Backup_DB from "./sql_all_components_complete/SQLs_Backup_DB.jsx";
import SQLs_Between from "./sql_all_components_complete/SQLs_Between.jsx";
import SQLs_Case from "./sql_all_components_complete/SQLs_Case.jsx";
import SQLs_Check from "./sql_all_components_complete/SQLs_Check.jsx";
import SQLs_Constraints from "./sql_all_components_complete/SQLs_Constraints.jsx";
import SQLs_Create_DB from "./sql_all_components_complete/SQLs_Create_DB.jsx";
import SQLs_Create_Table from "./sql_all_components_complete/SQLs_Create_Table.jsx";
import SQLs_Data_Types from "./sql_all_components_complete/SQLs_Data_Types.jsx";
import SQLs_Dates from "./sql_all_components_complete/SQLs_Dates.jsx";
import SQLs_Default from "./sql_all_components_complete/SQLs_Default.jsx";
import SQLs_Delete from "./sql_all_components_complete/SQLs_Delete.jsx";
import SQLs_Drop_DB from "./sql_all_components_complete/SQLs_Drop_DB.jsx";
import SQLs_Drop_Table from "./sql_all_components_complete/SQLs_Drop_Table.jsx";
import SQLs_Exists from "./sql_all_components_complete/SQLs_Exists.jsx";
import SQLs_Foreign_Key from "./sql_all_components_complete/SQLs_Foreign_Key.jsx";
import SQLs_Group_By from "./sql_all_components_complete/SQLs_Group_By.jsx";
import SQLs_Having from "./sql_all_components_complete/SQLs_Having.jsx";
import SQLs_Hosting from "./sql_all_components_complete/SQLs_Hosting.jsx";
import SQLs_In from "./sql_all_components_complete/SQLs_In.jsx";
import SQLs_Index from "./sql_all_components_complete/SQLs_Index.jsx";
import SQLs_Injection from "./sql_all_components_complete/SQLs_Injection.jsx";
import SQLs_Inner_Join from "./sql_all_components_complete/SQLs_Inner_Join.jsx";
import SQLs_Insert_Into_Select from "./sql_all_components_complete/SQLs_Insert_Into_Select.jsx";
import SQLs_Joins from "./sql_all_components_complete/SQLs_Joins.jsx";
import SQLs_Left_Join from "./sql_all_components_complete/SQLs_Left_Join.jsx";
import SQLs_Like from "./sql_all_components_complete/SQLs_Like.jsx";
import SQLs_Not from "./sql_all_components_complete/SQLs_Not.jsx";
import SQLs_Not_Null from "./sql_all_components_complete/SQLs_Not_Null.jsx";
import SQLs_Or from "./sql_all_components_complete/SQLs_Or.jsx";
import SQLs_Primary_Key from "./sql_all_components_complete/SQLs_Primary_Key.jsx";
import SQLs_Right_Join from "./sql_all_components_complete/SQLs_Right_Join.jsx";
import SQLs_Select_Into from "./sql_all_components_complete/SQLs_Select_Into.jsx";
import SQLs_Select_Top from "./sql_all_components_complete/SQLs_Select_Top.jsx";
import SQLs_Union from "./sql_all_components_complete/SQLs_Union.jsx";
import SQLs_Union_All from "./sql_all_components_complete/SQLs_Union_All.jsx";
import SQLs_Unique from "./sql_all_components_complete/SQLs_Unique.jsx";
import SQLs_Update from "./sql_all_components_complete/SQLs_Update.jsx";
import SQLs_Views from "./sql_all_components_complete/SQLs_Views.jsx";
import SQLs_Where from "./sql_all_components_complete/SQLs_Where.jsx";
import MSAccess_Abs from "./sql_all_components_complete/MSAccess_Abs.jsx";
import MSAccess_Asc from "./sql_all_components_complete/MSAccess_Asc.jsx";
import MSAccess_Atn from "./sql_all_components_complete/MSAccess_Atn.jsx";
import MSAccess_Avg from "./sql_all_components_complete/MSAccess_Avg.jsx";
import MSAccess_Chr from "./sql_all_components_complete/MSAccess_Chr.jsx";
import MSAccess_Concat_And from "./sql_all_components_complete/MSAccess_Concat_And.jsx";
import MSAccess_Cos from "./sql_all_components_complete/MSAccess_Cos.jsx";
import MSAccess_Count from "./sql_all_components_complete/MSAccess_Count.jsx";
import MSAccess_CurDir from "./sql_all_components_complete/MSAccess_CurDir.jsx";
import MSAccess_CurrentUser from "./sql_all_components_complete/MSAccess_CurrentUser.jsx";
import MSAccess_Date from "./sql_all_components_complete/MSAccess_Date.jsx";
import MSAccess_DateAdd from "./sql_all_components_complete/MSAccess_DateAdd.jsx";
import MSAccess_DateDiff from "./sql_all_components_complete/MSAccess_DateDiff.jsx";
import MSAccess_DatePart from "./sql_all_components_complete/MSAccess_DatePart.jsx";
import MSAccess_DateSerial from "./sql_all_components_complete/MSAccess_DateSerial.jsx";
import MSAccess_DateValue from "./sql_all_components_complete/MSAccess_DateValue.jsx";
import MSAccess_Day from "./sql_all_components_complete/MSAccess_Day.jsx";
import MSAccess_Environ from "./sql_all_components_complete/MSAccess_Environ.jsx";
import MSAccess_Exp from "./sql_all_components_complete/MSAccess_Exp.jsx";
import MSAccess_Fix from "./sql_all_components_complete/MSAccess_Fix.jsx";
import MSAccess_Format from "./sql_all_components_complete/MSAccess_Format.jsx";
import MSAccess_Format_Date from "./sql_all_components_complete/MSAccess_Format_Date.jsx";
import MSAccess_Hour from "./sql_all_components_complete/MSAccess_Hour.jsx";
import MSAccess_InStr from "./sql_all_components_complete/MSAccess_InStr.jsx";
import MSAccess_InStrRev from "./sql_all_components_complete/MSAccess_InStrRev.jsx";
import MSAccess_Int from "./sql_all_components_complete/MSAccess_Int.jsx";
import MSAccess_IsDate from "./sql_all_components_complete/MSAccess_IsDate.jsx";
import MSAccess_IsNull from "./sql_all_components_complete/MSAccess_IsNull.jsx";
import MSAccess_IsNumeric from "./sql_all_components_complete/MSAccess_IsNumeric.jsx";
import MSAccess_LCase from "./sql_all_components_complete/MSAccess_LCase.jsx";
import MSAccess_Left from "./sql_all_components_complete/MSAccess_Left.jsx";
import MSAccess_Len from "./sql_all_components_complete/MSAccess_Len.jsx";
import MSAccess_LTrim from "./sql_all_components_complete/MSAccess_LTrim.jsx";
import MSAccess_Max from "./sql_all_components_complete/MSAccess_Max.jsx";
import MSAccess_Mid from "./sql_all_components_complete/MSAccess_Mid.jsx";
import MSAccess_Min from "./sql_all_components_complete/MSAccess_Min.jsx";
import MSAccess_Minute from "./sql_all_components_complete/MSAccess_Minute.jsx";
import MSAccess_Month from "./sql_all_components_complete/MSAccess_Month.jsx";
import MSAccess_MonthName from "./sql_all_components_complete/MSAccess_MonthName.jsx";
import MSAccess_Now from "./sql_all_components_complete/MSAccess_Now.jsx";
import MSAccess_Randomize from "./sql_all_components_complete/MSAccess_Randomize.jsx";
import MSAccess_Replace from "./sql_all_components_complete/MSAccess_Replace.jsx";
import MSAccess_Right from "./sql_all_components_complete/MSAccess_Right.jsx";
import MSAccess_Rnd from "./sql_all_components_complete/MSAccess_Rnd.jsx";
import MSAccess_Round from "./sql_all_components_complete/MSAccess_Round.jsx";
import MSAccess_RTrim from "./sql_all_components_complete/MSAccess_RTrim.jsx";
import MSAccess_Second from "./sql_all_components_complete/MSAccess_Second.jsx";
import MSAccess_Sgn from "./sql_all_components_complete/MSAccess_Sgn.jsx";
import MSAccess_Space from "./sql_all_components_complete/MSAccess_Space.jsx";
import MSAccess_Split from "./sql_all_components_complete/MSAccess_Split.jsx";
import MSAccess_Sqr from "./sql_all_components_complete/MSAccess_Sqr.jsx";
import MSAccess_Str from "./sql_all_components_complete/MSAccess_Str.jsx";
import MSAccess_StrComp from "./sql_all_components_complete/MSAccess_StrComp.jsx";
import MSAccess_StrConv from "./sql_all_components_complete/MSAccess_StrConv.jsx";
import MSAccess_StrReverse from "./sql_all_components_complete/MSAccess_StrReverse.jsx";
import MSAccess_Sum from "./sql_all_components_complete/MSAccess_Sum.jsx";
import MSAccess_Time from "./sql_all_components_complete/MSAccess_Time.jsx";
import MSAccess_TimeSerial from "./sql_all_components_complete/MSAccess_TimeSerial.jsx";
import MSAccess_TimeValue from "./sql_all_components_complete/MSAccess_TimeValue.jsx";
import MSAccess_Trim from "./sql_all_components_complete/MSAccess_Trim.jsx";
import MSAccess_UCase from "./sql_all_components_complete/MSAccess_UCase.jsx";
import MSAccess_Val from "./sql_all_components_complete/MSAccess_Val.jsx";
import MSAccess_Weekday from "./sql_all_components_complete/MSAccess_Weekday.jsx";
import MSAccess_WeekdayName from "./sql_all_components_complete/MSAccess_WeekdayName.jsx";
import MSAccess_Year from "./sql_all_components_complete/MSAccess_Year.jsx";
import MS_Access_Functions from "./sql_all_components_complete/MS_Access_Functions.jsx";
import MySQL_ABS from "./sql_all_components_complete/MySQL_ABS.jsx";
import MySQL_ACOS from "./sql_all_components_complete/MySQL_ACOS.jsx";
import MySQL_ADDDATE from "./sql_all_components_complete/MySQL_ADDDATE.jsx";
import MySQL_ADDTIME from "./sql_all_components_complete/MySQL_ADDTIME.jsx";
import MySQL_ASCII from "./sql_all_components_complete/MySQL_ASCII.jsx";
import MySQL_ASIN from "./sql_all_components_complete/MySQL_ASIN.jsx";
import MySQL_ATAN from "./sql_all_components_complete/MySQL_ATAN.jsx";
import MySQL_ATAN2 from "./sql_all_components_complete/MySQL_ATAN2.jsx";
import MySQL_AVG from "./sql_all_components_complete/MySQL_AVG.jsx";
import MySQL_BIN from "./sql_all_components_complete/MySQL_BIN.jsx";
import MySQL_BINARY from "./sql_all_components_complete/MySQL_BINARY.jsx";
import MySQL_CASE from "./sql_all_components_complete/MySQL_CASE.jsx";
import MySQL_CAST from "./sql_all_components_complete/MySQL_CAST.jsx";
import MySQL_CEIL from "./sql_all_components_complete/MySQL_CEIL.jsx";
import MySQL_CEILING from "./sql_all_components_complete/MySQL_CEILING.jsx";
import MySQL_CHARACTER_LENGTH from "./sql_all_components_complete/MySQL_CHARACTER_LENGTH.jsx";
import MySQL_CHAR_LENGTH from "./sql_all_components_complete/MySQL_CHAR_LENGTH.jsx";
import MySQL_COALESCE from "./sql_all_components_complete/MySQL_COALESCE.jsx";
import MySQL_CONCAT from "./sql_all_components_complete/MySQL_CONCAT.jsx";
import MySQL_CONCAT_WS from "./sql_all_components_complete/MySQL_CONCAT_WS.jsx";
import MySQL_CONNECTION_ID from "./sql_all_components_complete/MySQL_CONNECTION_ID.jsx";
import MySQL_CONV from "./sql_all_components_complete/MySQL_CONV.jsx";
import MySQL_CONVERT from "./sql_all_components_complete/MySQL_CONVERT.jsx";
import MySQL_COS from "./sql_all_components_complete/MySQL_COS.jsx";
import MySQL_COT from "./sql_all_components_complete/MySQL_COT.jsx";
import MySQL_COUNT from "./sql_all_components_complete/MySQL_COUNT.jsx";
import MySQL_CURDATE from "./sql_all_components_complete/MySQL_CURDATE.jsx";
import MySQL_CURRENT_DATE from "./sql_all_components_complete/MySQL_CURRENT_DATE.jsx";
import MySQL_CURRENT_TIME from "./sql_all_components_complete/MySQL_CURRENT_TIME.jsx";
import MySQL_CURRENT_TIMESTAMP from "./sql_all_components_complete/MySQL_CURRENT_TIMESTAMP.jsx";
import MySQL_CURRENT_USER from "./sql_all_components_complete/MySQL_CURRENT_USER.jsx";
import MySQL_CURTIME from "./sql_all_components_complete/MySQL_CURTIME.jsx";
import MySQL_DATABASE from "./sql_all_components_complete/MySQL_DATABASE.jsx";
import MySQL_DATE from "./sql_all_components_complete/MySQL_DATE.jsx";
import MySQL_DATEDIFF from "./sql_all_components_complete/MySQL_DATEDIFF.jsx";
import MySQL_DATE_ADD from "./sql_all_components_complete/MySQL_DATE_ADD.jsx";
import MySQL_DATE_FORMAT from "./sql_all_components_complete/MySQL_DATE_FORMAT.jsx";
import MySQL_DATE_SUB from "./sql_all_components_complete/MySQL_DATE_SUB.jsx";
import MySQL_DAY from "./sql_all_components_complete/MySQL_DAY.jsx";
import MySQL_DAYNAME from "./sql_all_components_complete/MySQL_DAYNAME.jsx";
import MySQL_DAYOFMONTH from "./sql_all_components_complete/MySQL_DAYOFMONTH.jsx";
import MySQL_DAYOFWEEK from "./sql_all_components_complete/MySQL_DAYOFWEEK.jsx";
import MySQL_DAYOFYEAR from "./sql_all_components_complete/MySQL_DAYOFYEAR.jsx";
import MySQL_DEGREES from "./sql_all_components_complete/MySQL_DEGREES.jsx";
import MySQL_DIV from "./sql_all_components_complete/MySQL_DIV.jsx";
import MySQL_EXP from "./sql_all_components_complete/MySQL_EXP.jsx";
import MySQL_EXTRACT from "./sql_all_components_complete/MySQL_EXTRACT.jsx";
import MySQL_FIELD from "./sql_all_components_complete/MySQL_FIELD.jsx";
import MySQL_FIND_IN_SET from "./sql_all_components_complete/MySQL_FIND_IN_SET.jsx";
import MySQL_FLOOR from "./sql_all_components_complete/MySQL_FLOOR.jsx";
import MySQL_FORMAT from "./sql_all_components_complete/MySQL_FORMAT.jsx";
import MySQL_FROM_DAYS from "./sql_all_components_complete/MySQL_FROM_DAYS.jsx";
import MySQL_Functions from "./sql_all_components_complete/MySQL_Functions.jsx";
import MySQL_GREATEST from "./sql_all_components_complete/MySQL_GREATEST.jsx";
import MySQL_HOUR from "./sql_all_components_complete/MySQL_HOUR.jsx";
import MySQL_IF from "./sql_all_components_complete/MySQL_IF.jsx";
import MySQL_IFNULL from "./sql_all_components_complete/MySQL_IFNULL.jsx";
import MySQL_INSERT from "./sql_all_components_complete/MySQL_INSERT.jsx";
import MySQL_INSTR from "./sql_all_components_complete/MySQL_INSTR.jsx";
import MySQL_ISNULL from "./sql_all_components_complete/MySQL_ISNULL.jsx";
import MySQL_LAST_DAY from "./sql_all_components_complete/MySQL_LAST_DAY.jsx";
import MySQL_LAST_INSERT_ID from "./sql_all_components_complete/MySQL_LAST_INSERT_ID.jsx";
import MySQL_LCASE from "./sql_all_components_complete/MySQL_LCASE.jsx";
import MySQL_LEAST from "./sql_all_components_complete/MySQL_LEAST.jsx";
import MySQL_LEFT from "./sql_all_components_complete/MySQL_LEFT.jsx";
import MySQL_LENGTH from "./sql_all_components_complete/MySQL_LENGTH.jsx";
import MySQL_LN from "./sql_all_components_complete/MySQL_LN.jsx";
import MySQL_LOCALTIME from "./sql_all_components_complete/MySQL_LOCALTIME.jsx";
import MySQL_LOCALTIMESTAMP from "./sql_all_components_complete/MySQL_LOCALTIMESTAMP.jsx";
import MySQL_LOCATE from "./sql_all_components_complete/MySQL_LOCATE.jsx";
import MySQL_LOG from "./sql_all_components_complete/MySQL_LOG.jsx";
import MySQL_LOG10 from "./sql_all_components_complete/MySQL_LOG10.jsx";
import MySQL_LOG2 from "./sql_all_components_complete/MySQL_LOG2.jsx";
import MySQL_LOWER from "./sql_all_components_complete/MySQL_LOWER.jsx";
import MySQL_LPAD from "./sql_all_components_complete/MySQL_LPAD.jsx";
import MySQL_LTRIM from "./sql_all_components_complete/MySQL_LTRIM.jsx";
import MySQL_MAKEDATE from "./sql_all_components_complete/MySQL_MAKEDATE.jsx";
import MySQL_MAKETIME from "./sql_all_components_complete/MySQL_MAKETIME.jsx";
import MySQL_MAX from "./sql_all_components_complete/MySQL_MAX.jsx";
import MySQL_MICROSECOND from "./sql_all_components_complete/MySQL_MICROSECOND.jsx";
import MySQL_MID from "./sql_all_components_complete/MySQL_MID.jsx";
import MySQL_MIN from "./sql_all_components_complete/MySQL_MIN.jsx";
import MySQL_MINUTE from "./sql_all_components_complete/MySQL_MINUTE.jsx";
import MySQL_MOD from "./sql_all_components_complete/MySQL_MOD.jsx";
import MySQL_MONTH from "./sql_all_components_complete/MySQL_MONTH.jsx";
import MySQL_MONTHNAME from "./sql_all_components_complete/MySQL_MONTHNAME.jsx";
import MySQL_NOW from "./sql_all_components_complete/MySQL_NOW.jsx";
import MySQL_NULLIF from "./sql_all_components_complete/MySQL_NULLIF.jsx";
import MySQL_PERIOD_ADD from "./sql_all_components_complete/MySQL_PERIOD_ADD.jsx";
import MySQL_PERIOD_DIFF from "./sql_all_components_complete/MySQL_PERIOD_DIFF.jsx";
import MySQL_PI from "./sql_all_components_complete/MySQL_PI.jsx";
import MySQL_POSITION from "./sql_all_components_complete/MySQL_POSITION.jsx";
import MySQL_POW from "./sql_all_components_complete/MySQL_POW.jsx";
import MySQL_POWER from "./sql_all_components_complete/MySQL_POWER.jsx";
import MySQL_QUARTER from "./sql_all_components_complete/MySQL_QUARTER.jsx";
import MySQL_RADIANS from "./sql_all_components_complete/MySQL_RADIANS.jsx";
import MySQL_RAND from "./sql_all_components_complete/MySQL_RAND.jsx";
import MySQL_REPEAT from "./sql_all_components_complete/MySQL_REPEAT.jsx";
import MySQL_REPLACE from "./sql_all_components_complete/MySQL_REPLACE.jsx";
import MySQL_REVERSE from "./sql_all_components_complete/MySQL_REVERSE.jsx";
import MySQL_RIGHT from "./sql_all_components_complete/MySQL_RIGHT.jsx";
import MySQL_ROUND from "./sql_all_components_complete/MySQL_ROUND.jsx";
import MySQL_RPAD from "./sql_all_components_complete/MySQL_RPAD.jsx";
import MySQL_RTRIM from "./sql_all_components_complete/MySQL_RTRIM.jsx";
import MySQL_SECOND from "./sql_all_components_complete/MySQL_SECOND.jsx";
import MySQL_SEC_TO_TIME from "./sql_all_components_complete/MySQL_SEC_TO_TIME.jsx";
import MySQL_SESSION_USER from "./sql_all_components_complete/MySQL_SESSION_USER.jsx";
import MySQL_SIGN from "./sql_all_components_complete/MySQL_SIGN.jsx";
import MySQL_SIN from "./sql_all_components_complete/MySQL_SIN.jsx";
import MySQL_SPACE from "./sql_all_components_complete/MySQL_SPACE.jsx";
import MySQL_SQRT from "./sql_all_components_complete/MySQL_SQRT.jsx";
import MySQL_STRCMP from "./sql_all_components_complete/MySQL_STRCMP.jsx";
import MySQL_STR_TO_DATE from "./sql_all_components_complete/MySQL_STR_TO_DATE.jsx";
import MySQL_SUBDATE from "./sql_all_components_complete/MySQL_SUBDATE.jsx";
import MySQL_SUBSTR from "./sql_all_components_complete/MySQL_SUBSTR.jsx";
import MySQL_SUBSTRING from "./sql_all_components_complete/MySQL_SUBSTRING.jsx";
import MySQL_SUBSTRING_INDEX from "./sql_all_components_complete/MySQL_SUBSTRING_INDEX.jsx";
import MySQL_SUBTIME from "./sql_all_components_complete/MySQL_SUBTIME.jsx";
import MySQL_SUM from "./sql_all_components_complete/MySQL_SUM.jsx";
import MySQL_SYSDATE from "./sql_all_components_complete/MySQL_SYSDATE.jsx";
import MySQL_SYSTEM_USER from "./sql_all_components_complete/MySQL_SYSTEM_USER.jsx";
import MySQL_TAN from "./sql_all_components_complete/MySQL_TAN.jsx";
import MySQL_TIME from "./sql_all_components_complete/MySQL_TIME.jsx";
import MySQL_TIMEDIFF from "./sql_all_components_complete/MySQL_TIMEDIFF.jsx";
import MySQL_TIMESTAMP from "./sql_all_components_complete/MySQL_TIMESTAMP.jsx";
import MySQL_TIME_FORMAT from "./sql_all_components_complete/MySQL_TIME_FORMAT.jsx";
import MySQL_TIME_TO_SEC from "./sql_all_components_complete/MySQL_TIME_TO_SEC.jsx";
import MySQL_TO_DAYS from "./sql_all_components_complete/MySQL_TO_DAYS.jsx";
import MySQL_TRIM from "./sql_all_components_complete/MySQL_TRIM.jsx";
import MySQL_TRUNCATE from "./sql_all_components_complete/MySQL_TRUNCATE.jsx";
import MySQL_UCASE from "./sql_all_components_complete/MySQL_UCASE.jsx";
import MySQL_UPPER from "./sql_all_components_complete/MySQL_UPPER.jsx";
import MySQL_USER from "./sql_all_components_complete/MySQL_USER.jsx";
import MySQL_VERSION from "./sql_all_components_complete/MySQL_VERSION.jsx";
import MySQL_WEEK from "./sql_all_components_complete/MySQL_WEEK.jsx";
import MySQL_WEEKDAY from "./sql_all_components_complete/MySQL_WEEKDAY.jsx";
import MySQL_WEEKOFYEAR from "./sql_all_components_complete/MySQL_WEEKOFYEAR.jsx";
import MySQL_YEAR from "./sql_all_components_complete/MySQL_YEAR.jsx";
import MySQL_YEARWEEK from "./sql_all_components_complete/MySQL_YEARWEEK.jsx";
import SQLServer_ABS from "./sql_all_components_complete/SQLServer_ABS.jsx";
import SQLServer_ACOS from "./sql_all_components_complete/SQLServer_ACOS.jsx";
import SQLServer_ASCII from "./sql_all_components_complete/SQLServer_ASCII.jsx";
import SQLServer_ASIN from "./sql_all_components_complete/SQLServer_ASIN.jsx";
import SQLServer_ATAN from "./sql_all_components_complete/SQLServer_ATAN.jsx";
import SQLServer_ATN2 from "./sql_all_components_complete/SQLServer_ATN2.jsx";
import SQLServer_AVG from "./sql_all_components_complete/SQLServer_AVG.jsx";
import SQLServer_CAST from "./sql_all_components_complete/SQLServer_CAST.jsx";
import SQLServer_CEILING from "./sql_all_components_complete/SQLServer_CEILING.jsx";
import SQLServer_CHAR from "./sql_all_components_complete/SQLServer_CHAR.jsx";
import SQLServer_CHARINDEX from "./sql_all_components_complete/SQLServer_CHARINDEX.jsx";
import SQLServer_COALESCE from "./sql_all_components_complete/SQLServer_COALESCE.jsx";
import SQLServer_CONCAT from "./sql_all_components_complete/SQLServer_CONCAT.jsx";
import SQLServer_CONCAT_PLUS from "./sql_all_components_complete/SQLServer_CONCAT_PLUS.jsx";
import SQLServer_CONCAT_WS from "./sql_all_components_complete/SQLServer_CONCAT_WS.jsx";
import SQLServer_CONVERT from "./sql_all_components_complete/SQLServer_CONVERT.jsx";
import SQLServer_COS from "./sql_all_components_complete/SQLServer_COS.jsx";
import SQLServer_COT from "./sql_all_components_complete/SQLServer_COT.jsx";
import SQLServer_COUNT from "./sql_all_components_complete/SQLServer_COUNT.jsx";
import SQLServer_CURRENT_TIMESTAMP from "./sql_all_components_complete/SQLServer_CURRENT_TIMESTAMP.jsx";
import SQLServer_CURRENT_USER from "./sql_all_components_complete/SQLServer_CURRENT_USER.jsx";
import SQLServer_DATALENGTH from "./sql_all_components_complete/SQLServer_DATALENGTH.jsx";
import SQLServer_DATEADD from "./sql_all_components_complete/SQLServer_DATEADD.jsx";
import SQLServer_DATEDIFF from "./sql_all_components_complete/SQLServer_DATEDIFF.jsx";
import SQLServer_DATEFROMPARTS from "./sql_all_components_complete/SQLServer_DATEFROMPARTS.jsx";
import SQLServer_DATENAME from "./sql_all_components_complete/SQLServer_DATENAME.jsx";
import SQLServer_DATEPART from "./sql_all_components_complete/SQLServer_DATEPART.jsx";
import SQLServer_DAY from "./sql_all_components_complete/SQLServer_DAY.jsx";
import SQLServer_DEGREES from "./sql_all_components_complete/SQLServer_DEGREES.jsx";
import SQLServer_DIFFERENCE from "./sql_all_components_complete/SQLServer_DIFFERENCE.jsx";
import SQLServer_EXP from "./sql_all_components_complete/SQLServer_EXP.jsx";
import SQLServer_FLOOR from "./sql_all_components_complete/SQLServer_FLOOR.jsx";
import SQLServer_FORMAT from "./sql_all_components_complete/SQLServer_FORMAT.jsx";
import SQLServer_GETDATE from "./sql_all_components_complete/SQLServer_GETDATE.jsx";
import SQLServer_GETUTCDATE from "./sql_all_components_complete/SQLServer_GETUTCDATE.jsx";
import SQLServer_IIF from "./sql_all_components_complete/SQLServer_IIF.jsx";
import SQLServer_ISDATE from "./sql_all_components_complete/SQLServer_ISDATE.jsx";
import SQLServer_ISNULL from "./sql_all_components_complete/SQLServer_ISNULL.jsx";
import SQLServer_ISNUMERIC from "./sql_all_components_complete/SQLServer_ISNUMERIC.jsx";
import SQLServer_LEFT from "./sql_all_components_complete/SQLServer_LEFT.jsx";
import SQLServer_LEN from "./sql_all_components_complete/SQLServer_LEN.jsx";
import SQLServer_LOG from "./sql_all_components_complete/SQLServer_LOG.jsx";
import SQLServer_LOG10 from "./sql_all_components_complete/SQLServer_LOG10.jsx";
import SQLServer_LOWER from "./sql_all_components_complete/SQLServer_LOWER.jsx";
import SQLServer_LTRIM from "./sql_all_components_complete/SQLServer_LTRIM.jsx";
import SQLServer_MAX from "./sql_all_components_complete/SQLServer_MAX.jsx";
import SQLServer_MIN from "./sql_all_components_complete/SQLServer_MIN.jsx";
import SQLServer_MONTH from "./sql_all_components_complete/SQLServer_MONTH.jsx";
import SQLServer_NCHAR from "./sql_all_components_complete/SQLServer_NCHAR.jsx";
import SQLServer_NULLIF from "./sql_all_components_complete/SQLServer_NULLIF.jsx";
import SQLServer_PATINDEX from "./sql_all_components_complete/SQLServer_PATINDEX.jsx";
import SQLServer_PI from "./sql_all_components_complete/SQLServer_PI.jsx";
import SQLServer_POWER from "./sql_all_components_complete/SQLServer_POWER.jsx";
import SQLServer_QUOTENAME from "./sql_all_components_complete/SQLServer_QUOTENAME.jsx";
import SQLServer_RADIANS from "./sql_all_components_complete/SQLServer_RADIANS.jsx";
import SQLServer_RAND from "./sql_all_components_complete/SQLServer_RAND.jsx";
import SQLServer_REPLACE from "./sql_all_components_complete/SQLServer_REPLACE.jsx";
import SQLServer_REPLICATE from "./sql_all_components_complete/SQLServer_REPLICATE.jsx";
import SQLServer_REVERSE from "./sql_all_components_complete/SQLServer_REVERSE.jsx";
import SQLServer_RIGHT from "./sql_all_components_complete/SQLServer_RIGHT.jsx";
import SQLServer_ROUND from "./sql_all_components_complete/SQLServer_ROUND.jsx";
import SQLServer_RTRIM from "./sql_all_components_complete/SQLServer_RTRIM.jsx";
import SQLServer_SESSIONPROPERTY from "./sql_all_components_complete/SQLServer_SESSIONPROPERTY.jsx";
import SQLServer_SESSION_USER from "./sql_all_components_complete/SQLServer_SESSION_USER.jsx";
import SQLServer_SIGN from "./sql_all_components_complete/SQLServer_SIGN.jsx";
import SQLServer_SIN from "./sql_all_components_complete/SQLServer_SIN.jsx";
import SQLServer_SOUNDEX from "./sql_all_components_complete/SQLServer_SOUNDEX.jsx";
import SQLServer_SPACE from "./sql_all_components_complete/SQLServer_SPACE.jsx";
import SQLServer_SQRT from "./sql_all_components_complete/SQLServer_SQRT.jsx";
import SQLServer_SQUARE from "./sql_all_components_complete/SQLServer_SQUARE.jsx";
import SQLServer_STR from "./sql_all_components_complete/SQLServer_STR.jsx";
import SQLServer_STUFF from "./sql_all_components_complete/SQLServer_STUFF.jsx";
import SQLServer_SUBSTRING from "./sql_all_components_complete/SQLServer_SUBSTRING.jsx";
import SQLServer_SUM from "./sql_all_components_complete/SQLServer_SUM.jsx";
import SQLServer_SYSDATETIME from "./sql_all_components_complete/SQLServer_SYSDATETIME.jsx";
import SQLServer_SYSTEM_USER from "./sql_all_components_complete/SQLServer_SYSTEM_USER.jsx";
import SQLServer_TAN from "./sql_all_components_complete/SQLServer_TAN.jsx";
import SQLServer_TRANSLATE from "./sql_all_components_complete/SQLServer_TRANSLATE.jsx";
import SQLServer_TRIM from "./sql_all_components_complete/SQLServer_TRIM.jsx";
import SQLServer_UNICODE from "./sql_all_components_complete/SQLServer_UNICODE.jsx";
import SQLServer_UPPER from "./sql_all_components_complete/SQLServer_UPPER.jsx";
import SQLServer_USER_NAME from "./sql_all_components_complete/SQLServer_USER_NAME.jsx";
import SQLServer_YEAR from "./sql_all_components_complete/SQLServer_YEAR.jsx";
import SQL_ADD from "./sql_all_components_complete/SQL_ADD.jsx";
import SQL_ADD_CONSTRAINT from "./sql_all_components_complete/SQL_ADD_CONSTRAINT.jsx";
import SQL_Aggregate_Functions from "./sql_all_components_complete/SQL_Aggregate_Functions.jsx";
import SQL_Aliases from "./sql_all_components_complete/SQL_Aliases.jsx";
import SQL_ALL from "./sql_all_components_complete/SQL_ALL.jsx";
import SQL_ALTER from "./sql_all_components_complete/SQL_ALTER.jsx";
import SQL_ALTER_COLUMN from "./sql_all_components_complete/SQL_ALTER_COLUMN.jsx";
import SQL_ALTER_TABLE from "./sql_all_components_complete/SQL_ALTER_TABLE.jsx";
import SQL_AND from "./sql_all_components_complete/SQL_AND.jsx";
import SQL_ANY from "./sql_all_components_complete/SQL_ANY.jsx";
import SQL_Any_All from "./sql_all_components_complete/SQL_Any_All.jsx";
import SQL_AS from "./sql_all_components_complete/SQL_AS.jsx";
import SQL_ASC from "./sql_all_components_complete/SQL_ASC.jsx";
import SQL_Auto_Increment from "./sql_all_components_complete/SQL_Auto_Increment.jsx";
import SQL_Avg from "./sql_all_components_complete/SQL_Avg.jsx";
import SQL_BACKUP_DATABASE from "./sql_all_components_complete/SQL_BACKUP_DATABASE.jsx";
import SQL_Backup_DB from "./sql_all_components_complete/SQL_Backup_DB.jsx";
import SQL_BETWEEN from "./sql_all_components_complete/SQL_BETWEEN.jsx";
import SQL_Bootcamp from "./sql_all_components_complete/SQL_Bootcamp.jsx";
import SQL_CASE from "./sql_all_components_complete/SQL_CASE.jsx";
import SQL_Certificate from "./sql_all_components_complete/SQL_Certificate.jsx";
import SQL_CHECK from "./sql_all_components_complete/SQL_CHECK.jsx";
import SQL_COLUMN from "./sql_all_components_complete/SQL_COLUMN.jsx";
import SQL_Comments from "./sql_all_components_complete/SQL_Comments.jsx";
import SQL_CONSTRAINT from "./sql_all_components_complete/SQL_CONSTRAINT.jsx";
import SQL_Constraints from "./sql_all_components_complete/SQL_Constraints.jsx";
import SQL_Count from "./sql_all_components_complete/SQL_Count.jsx";
import SQL_CREATE from "./sql_all_components_complete/SQL_CREATE.jsx";
import SQL_CREATE_DATABASE from "./sql_all_components_complete/SQL_CREATE_DATABASE.jsx";
import SQL_Create_DB from "./sql_all_components_complete/SQL_Create_DB.jsx";
import SQL_CREATE_INDEX from "./sql_all_components_complete/SQL_CREATE_INDEX.jsx";
import SQL_CREATE_OR_REPLACE_VIEW from "./sql_all_components_complete/SQL_CREATE_OR_REPLACE_VIEW.jsx";
import SQL_CREATE_PROCEDURE from "./sql_all_components_complete/SQL_CREATE_PROCEDURE.jsx";
import SQL_CREATE_TABLE from "./sql_all_components_complete/SQL_CREATE_TABLE.jsx";
import SQL_CREATE_UNIQUE_INDEX from "./sql_all_components_complete/SQL_CREATE_UNIQUE_INDEX.jsx";
import SQL_CREATE_VIEW from "./sql_all_components_complete/SQL_CREATE_VIEW.jsx";
import SQL_DATABASE from "./sql_all_components_complete/SQL_DATABASE.jsx";
import SQL_Data_Types from "./sql_all_components_complete/SQL_Data_Types.jsx";
import SQL_Dates from "./sql_all_components_complete/SQL_Dates.jsx";
import SQL_DEFAULT from "./sql_all_components_complete/SQL_DEFAULT.jsx";
import SQL_DELETE from "./sql_all_components_complete/SQL_DELETE.jsx";
import SQL_DESC from "./sql_all_components_complete/SQL_DESC.jsx";
import SQL_DISTINCT from "./sql_all_components_complete/SQL_DISTINCT.jsx";
import SQL_DROP from "./sql_all_components_complete/SQL_DROP.jsx";
import SQL_DROP_COLUMN from "./sql_all_components_complete/SQL_DROP_COLUMN.jsx";
import SQL_DROP_CONSTRAINT from "./sql_all_components_complete/SQL_DROP_CONSTRAINT.jsx";
import SQL_DROP_DATABASE from "./sql_all_components_complete/SQL_DROP_DATABASE.jsx";
import SQL_Drop_DB from "./sql_all_components_complete/SQL_Drop_DB.jsx";
import SQL_DROP_DEFAULT from "./sql_all_components_complete/SQL_DROP_DEFAULT.jsx";
import SQL_DROP_INDEX from "./sql_all_components_complete/SQL_DROP_INDEX.jsx";
import SQL_DROP_TABLE from "./sql_all_components_complete/SQL_DROP_TABLE.jsx";
import SQL_DROP_VIEW from "./sql_all_components_complete/SQL_DROP_VIEW.jsx";
import SQL_Editor from "./sql_all_components_complete/SQL_Editor.jsx";
import SQL_Examples from "./sql_all_components_complete/SQL_Examples.jsx";
import SQL_EXEC from "./sql_all_components_complete/SQL_EXEC.jsx";
import SQL_Exercises from "./sql_all_components_complete/SQL_Exercises.jsx";
import SQL_EXISTS from "./sql_all_components_complete/SQL_EXISTS.jsx";
import SQL_FOREIGN_KEY from "./sql_all_components_complete/SQL_FOREIGN_KEY.jsx";
import SQL_FROM from "./sql_all_components_complete/SQL_FROM.jsx";
import SQL_Full_Join from "./sql_all_components_complete/SQL_Full_Join.jsx";
import SQL_FULL_OUTER_JOIN from "./sql_all_components_complete/SQL_FULL_OUTER_JOIN.jsx";
import SQL_GROUP_BY from "./sql_all_components_complete/SQL_GROUP_BY.jsx";
import SQL_HAVING from "./sql_all_components_complete/SQL_HAVING.jsx";
import SQL_Home from "./sql_all_components_complete/SQL_Home.jsx";
import SQL_Hosting from "./sql_all_components_complete/SQL_Hosting.jsx";
import SQL_IN from "./sql_all_components_complete/SQL_IN.jsx";
import SQL_INDEX from "./sql_all_components_complete/SQL_INDEX.jsx";
import SQL_Injection from "./sql_all_components_complete/SQL_Injection.jsx";
import SQL_INNER_JOIN from "./sql_all_components_complete/SQL_INNER_JOIN.jsx";
import SQL_INSERT_INTO from "./sql_all_components_complete/SQL_INSERT_INTO.jsx";
import SQL_INSERT_INTO_SELECT from "./sql_all_components_complete/SQL_INSERT_INTO_SELECT.jsx";
import SQL_Intro from "./sql_all_components_complete/SQL_Intro.jsx";
import SQL_IS_NOT_NULL from "./sql_all_components_complete/SQL_IS_NOT_NULL.jsx";
import SQL_IS_NULL from "./sql_all_components_complete/SQL_IS_NULL.jsx";
import SQL_JOIN from "./sql_all_components_complete/SQL_JOIN.jsx";
import SQL_Joins from "./sql_all_components_complete/SQL_Joins.jsx";
import SQL_LEFT_JOIN from "./sql_all_components_complete/SQL_LEFT_JOIN.jsx";
import SQL_LIKE from "./sql_all_components_complete/SQL_LIKE.jsx";
import SQL_LIMIT from "./sql_all_components_complete/SQL_LIMIT.jsx";
import SQL_Min_Max from "./sql_all_components_complete/SQL_Min_Max.jsx";
import SQL_NOT from "./sql_all_components_complete/SQL_NOT.jsx";
import SQL_NOT_NULL from "./sql_all_components_complete/SQL_NOT_NULL.jsx";
import SQL_Null_Functions from "./sql_all_components_complete/SQL_Null_Functions.jsx";
import SQL_Null_Values from "./sql_all_components_complete/SQL_Null_Values.jsx";
import SQL_Operators from "./sql_all_components_complete/SQL_Operators.jsx";
import SQL_OR from "./sql_all_components_complete/SQL_OR.jsx";
import SQL_ORDER_BY from "./sql_all_components_complete/SQL_ORDER_BY.jsx";
import SQL_OUTER_JOIN from "./sql_all_components_complete/SQL_OUTER_JOIN.jsx";
import SQL_PRIMARY_KEY from "./sql_all_components_complete/SQL_PRIMARY_KEY.jsx";
import SQL_PROCEDURE from "./sql_all_components_complete/SQL_PROCEDURE.jsx";
import SQL_Quick_Ref from "./sql_all_components_complete/SQL_Quick_Ref.jsx";
import SQL_Quiz from "./sql_all_components_complete/SQL_Quiz.jsx";
import SQL_RIGHT_JOIN from "./sql_all_components_complete/SQL_RIGHT_JOIN.jsx";
import SQL_ROWNUM from "./sql_all_components_complete/SQL_ROWNUM.jsx";
import SQL_SELECT from "./sql_all_components_complete/SQL_SELECT.jsx";
import SQL_SELECT_DISTINCT from "./sql_all_components_complete/SQL_SELECT_DISTINCT.jsx";
import SQL_SELECT_INTO from "./sql_all_components_complete/SQL_SELECT_INTO.jsx";
import SQL_SELECT_TOP from "./sql_all_components_complete/SQL_SELECT_TOP.jsx";
import SQL_Self_Join from "./sql_all_components_complete/SQL_Self_Join.jsx";
import SQL_Server from "./sql_all_components_complete/SQL_Server.jsx";
import SQL_Server_Functions from "./sql_all_components_complete/SQL_Server_Functions.jsx";
import SQL_SET from "./sql_all_components_complete/SQL_SET.jsx";
import SQL_Stored_Procedures from "./sql_all_components_complete/SQL_Stored_Procedures.jsx";
import SQL_Study_Plan from "./sql_all_components_complete/SQL_Study_Plan.jsx";
import SQL_Sum from "./sql_all_components_complete/SQL_Sum.jsx";
import SQL_Syllabus from "./sql_all_components_complete/SQL_Syllabus.jsx";
import SQL_Syntax from "./sql_all_components_complete/SQL_Syntax.jsx";
import SQL_TABLE from "./sql_all_components_complete/SQL_TABLE.jsx";
import SQL_TOP from "./sql_all_components_complete/SQL_TOP.jsx";
import SQL_Training from "./sql_all_components_complete/SQL_Training.jsx";
import SQL_TRUNCATE_TABLE from "./sql_all_components_complete/SQL_TRUNCATE_TABLE.jsx";
import SQL_UNION from "./sql_all_components_complete/SQL_UNION.jsx";
import SQL_UNION_ALL from "./sql_all_components_complete/SQL_UNION_ALL.jsx";
import SQL_UNIQUE from "./sql_all_components_complete/SQL_UNIQUE.jsx";
import SQL_UPDATE from "./sql_all_components_complete/SQL_UPDATE.jsx";
import SQL_VALUES from "./sql_all_components_complete/SQL_VALUES.jsx";
import SQL_VIEW from "./sql_all_components_complete/SQL_VIEW.jsx";
import SQL_Views from "./sql_all_components_complete/SQL_Views.jsx";
import SQL_WHERE from "./sql_all_components_complete/SQL_WHERE.jsx";
import SQL_Wildcards from "./sql_all_components_complete/SQL_Wildcards.jsx";
import SQL_Selects from "./sql_all_components_complete/SQL_Selects.jsx";
import SQL_Selects_Distinct from "./sql_all_components_complete/SQL_Selects_Distinct.jsx";
import SQLs_Order_By from "./sql_all_components_complete/SQLs_Order_By.jsx";
import SQLs_Inserts_Into from "./sql_all_components_complete/SQLs_Inserts_Into.jsx";
const SQLComponentsMap = {
  "<MSAccess_Abs />": MSAccess_Abs,
  "<SQLs_Inserts_Into />": SQLs_Inserts_Into,
  "<SQLs_Order_By />": SQLs_Order_By,
  "<MSAccess_Asc />": MSAccess_Asc,
  "<MSAccess_Atn />": MSAccess_Atn,
  "<MSAccess_Avg />": MSAccess_Avg,
  "<MSAccess_Chr />": MSAccess_Chr,
  "<MSAccess_Concat_And />": MSAccess_Concat_And,
  "<MSAccess_Cos />": MSAccess_Cos,
  "<MSAccess_Count />": MSAccess_Count,
  "<MSAccess_CurDir />": MSAccess_CurDir,
  "<MSAccess_CurrentUser />": MSAccess_CurrentUser,
  "<MSAccess_Date />": MSAccess_Date,
  "<MSAccess_DateAdd />": MSAccess_DateAdd,
  "<MSAccess_DateDiff />": MSAccess_DateDiff,
  "<MSAccess_DatePart />": MSAccess_DatePart,
  "<MSAccess_DateSerial />": MSAccess_DateSerial,
  "<MSAccess_DateValue />": MSAccess_DateValue,
  "<MSAccess_Day />": MSAccess_Day,
  "<MSAccess_Environ />": MSAccess_Environ,
  "<MSAccess_Exp />": MSAccess_Exp,
  "<MSAccess_Fix />": MSAccess_Fix,
  "<MSAccess_Format />": MSAccess_Format,
  "<MSAccess_Format_Date />": MSAccess_Format_Date,
  "<MSAccess_Hour />": MSAccess_Hour,
  "<MSAccess_InStr />": MSAccess_InStr,
  "<MSAccess_InStrRev />": MSAccess_InStrRev,
  "<MSAccess_Int />": MSAccess_Int,
  "<MSAccess_IsDate />": MSAccess_IsDate,
  "<MSAccess_IsNull />": MSAccess_IsNull,
  "<MSAccess_IsNumeric />": MSAccess_IsNumeric,
  "<MSAccess_LCase />": MSAccess_LCase,
  "<MSAccess_Left />": MSAccess_Left,
  "<MSAccess_Len />": MSAccess_Len,
  "<MSAccess_LTrim />": MSAccess_LTrim,
  "<MSAccess_Max />": MSAccess_Max,
  "<MSAccess_Mid />": MSAccess_Mid,
  "<MSAccess_Min />": MSAccess_Min,
  "<MSAccess_Minute />": MSAccess_Minute,
  "<MSAccess_Month />": MSAccess_Month,
  "<MSAccess_MonthName />": MSAccess_MonthName,
  "<MSAccess_Now />": MSAccess_Now,
  "<MSAccess_Randomize />": MSAccess_Randomize,
  "<MSAccess_Replace />": MSAccess_Replace,
  "<MSAccess_Right />": MSAccess_Right,
  "<MSAccess_Rnd />": MSAccess_Rnd,
  "<MSAccess_Round />": MSAccess_Round,
  "<MSAccess_RTrim />": MSAccess_RTrim,
  "<MSAccess_Second />": MSAccess_Second,
  "<MSAccess_Sgn />": MSAccess_Sgn,
  "<MSAccess_Space />": MSAccess_Space,
  "<MSAccess_Split />": MSAccess_Split,
  "<MSAccess_Sqr />": MSAccess_Sqr,
  "<MSAccess_Str />": MSAccess_Str,
  "<MSAccess_StrComp />": MSAccess_StrComp,
  "<MSAccess_StrConv />": MSAccess_StrConv,
  "<MSAccess_StrReverse />": MSAccess_StrReverse,
  "<MSAccess_Sum />": MSAccess_Sum,
  "<MSAccess_Time />": MSAccess_Time,
  "<MSAccess_TimeSerial />": MSAccess_TimeSerial,
  "<MSAccess_TimeValue />": MSAccess_TimeValue,
  "<MSAccess_Trim />": MSAccess_Trim,
  "<MSAccess_UCase />": MSAccess_UCase,
  "<MSAccess_Val />": MSAccess_Val,
  "<MSAccess_Weekday />": MSAccess_Weekday,
  "<MSAccess_WeekdayName />": MSAccess_WeekdayName,
  "<MSAccess_Year />": MSAccess_Year,
  "<MS_Access_Functions />": MS_Access_Functions,
  "<MySQL_ABS />": MySQL_ABS,
  "<MySQL_ACOS />": MySQL_ACOS,
  "<MySQL_ADDDATE />": MySQL_ADDDATE,
  "<MySQL_ADDTIME />": MySQL_ADDTIME,
  "<MySQL_ASCII />": MySQL_ASCII,
  "<MySQL_ASIN />": MySQL_ASIN,
  "<MySQL_ATAN />": MySQL_ATAN,
  "<MySQL_ATAN2 />": MySQL_ATAN2,
  "<MySQL_AVG />": MySQL_AVG,
  "<MySQL_BIN />": MySQL_BIN,
  "<MySQL_BINARY />": MySQL_BINARY,
  "<MySQL_CASE />": MySQL_CASE,
  "<MySQL_CAST />": MySQL_CAST,
  "<MySQL_CEIL />": MySQL_CEIL,
  "<MySQL_CEILING />": MySQL_CEILING,
  "<MySQL_CHARACTER_LENGTH />": MySQL_CHARACTER_LENGTH,
  "<MySQL_CHAR_LENGTH />": MySQL_CHAR_LENGTH,
  "<MySQL_COALESCE />": MySQL_COALESCE,
  "<MySQL_CONCAT />": MySQL_CONCAT,
  "<MySQL_CONCAT_WS />": MySQL_CONCAT_WS,
  "<MySQL_CONNECTION_ID />": MySQL_CONNECTION_ID,
  "<MySQL_CONV />": MySQL_CONV,
  "<MySQL_CONVERT />": MySQL_CONVERT,
  "<MySQL_COS />": MySQL_COS,
  "<MySQL_COT />": MySQL_COT,
  "<MySQL_COUNT />": MySQL_COUNT,
  "<MySQL_CURDATE />": MySQL_CURDATE,
  "<MySQL_CURRENT_DATE />": MySQL_CURRENT_DATE,
  "<MySQL_CURRENT_TIME />": MySQL_CURRENT_TIME,
  "<MySQL_CURRENT_TIMESTAMP />": MySQL_CURRENT_TIMESTAMP,
  "<MySQL_CURRENT_USER />": MySQL_CURRENT_USER,
  "<MySQL_CURTIME />": MySQL_CURTIME,
  "<MySQL_DATABASE />": MySQL_DATABASE,
  "<MySQL_DATE />": MySQL_DATE,
  "<MySQL_DATEDIFF />": MySQL_DATEDIFF,
  "<MySQL_DATE_ADD />": MySQL_DATE_ADD,
  "<MySQL_DATE_FORMAT />": MySQL_DATE_FORMAT,
  "<MySQL_DATE_SUB />": MySQL_DATE_SUB,
  "<MySQL_DAY />": MySQL_DAY,
  "<MySQL_DAYNAME />": MySQL_DAYNAME,
  "<MySQL_DAYOFMONTH />": MySQL_DAYOFMONTH,
  "<MySQL_DAYOFWEEK />": MySQL_DAYOFWEEK,
  "<MySQL_DAYOFYEAR />": MySQL_DAYOFYEAR,
  "<MySQL_DEGREES />": MySQL_DEGREES,
  "<MySQL_DIV />": MySQL_DIV,
  "<MySQL_EXP />": MySQL_EXP,
  "<MySQL_EXTRACT />": MySQL_EXTRACT,
  "<MySQL_FIELD />": MySQL_FIELD,
  "<MySQL_FIND_IN_SET />": MySQL_FIND_IN_SET,
  "<MySQL_FLOOR />": MySQL_FLOOR,
  "<MySQL_FORMAT />": MySQL_FORMAT,
  "<MySQL_FROM_DAYS />": MySQL_FROM_DAYS,
  "<MySQL_Functions />": MySQL_Functions,
  "<MySQL_GREATEST />": MySQL_GREATEST,
  "<MySQL_HOUR />": MySQL_HOUR,
  "<MySQL_IF />": MySQL_IF,
  "<MySQL_IFNULL />": MySQL_IFNULL,
  "<MySQL_INSERT />": MySQL_INSERT,
  "<MySQL_INSTR />": MySQL_INSTR,
  "<MySQL_ISNULL />": MySQL_ISNULL,
  "<MySQL_LAST_DAY />": MySQL_LAST_DAY,
  "<MySQL_LAST_INSERT_ID />": MySQL_LAST_INSERT_ID,
  "<MySQL_LCASE />": MySQL_LCASE,
  "<MySQL_LEAST />": MySQL_LEAST,
  "<MySQL_LEFT />": MySQL_LEFT,
  "<MySQL_LENGTH />": MySQL_LENGTH,
  "<MySQL_LN />": MySQL_LN,
  "<MySQL_LOCALTIME />": MySQL_LOCALTIME,
  "<MySQL_LOCALTIMESTAMP />": MySQL_LOCALTIMESTAMP,
  "<MySQL_LOCATE />": MySQL_LOCATE,
  "<MySQL_LOG />": MySQL_LOG,
  "<MySQL_LOG10 />": MySQL_LOG10,
  "<MySQL_LOG2 />": MySQL_LOG2,
  "<MySQL_LOWER />": MySQL_LOWER,
  "<MySQL_LPAD />": MySQL_LPAD,
  "<MySQL_LTRIM />": MySQL_LTRIM,
  "<MySQL_MAKEDATE />": MySQL_MAKEDATE,
  "<MySQL_MAKETIME />": MySQL_MAKETIME,
  "<MySQL_MAX />": MySQL_MAX,
  "<MySQL_MICROSECOND />": MySQL_MICROSECOND,
  "<MySQL_MID />": MySQL_MID,
  "<MySQL_MIN />": MySQL_MIN,
  "<MySQL_MINUTE />": MySQL_MINUTE,
  "<MySQL_MOD />": MySQL_MOD,
  "<MySQL_MONTH />": MySQL_MONTH,
  "<MySQL_MONTHNAME />": MySQL_MONTHNAME,
  "<MySQL_NOW />": MySQL_NOW,
  "<MySQL_NULLIF />": MySQL_NULLIF,
  "<MySQL_PERIOD_ADD />": MySQL_PERIOD_ADD,
  "<MySQL_PERIOD_DIFF />": MySQL_PERIOD_DIFF,
  "<MySQL_PI />": MySQL_PI,
  "<MySQL_POSITION />": MySQL_POSITION,
  "<MySQL_POW />": MySQL_POW,
  "<MySQL_POWER />": MySQL_POWER,
  "<MySQL_QUARTER />": MySQL_QUARTER,
  "<MySQL_RADIANS />": MySQL_RADIANS,
  "<MySQL_RAND />": MySQL_RAND,
  "<MySQL_REPEAT />": MySQL_REPEAT,
  "<MySQL_REPLACE />": MySQL_REPLACE,
  "<MySQL_REVERSE />": MySQL_REVERSE,
  "<MySQL_RIGHT />": MySQL_RIGHT,
  "<MySQL_ROUND />": MySQL_ROUND,
  "<MySQL_RPAD />": MySQL_RPAD,
  "<MySQL_RTRIM />": MySQL_RTRIM,
  "<MySQL_SECOND />": MySQL_SECOND,
  "<MySQL_SEC_TO_TIME />": MySQL_SEC_TO_TIME,
  "<MySQL_SESSION_USER />": MySQL_SESSION_USER,
  "<MySQL_SIGN />": MySQL_SIGN,
  "<MySQL_SIN />": MySQL_SIN,
  "<MySQL_SPACE />": MySQL_SPACE,
  "<MySQL_SQRT />": MySQL_SQRT,
  "<MySQL_STRCMP />": MySQL_STRCMP,
  "<MySQL_STR_TO_DATE />": MySQL_STR_TO_DATE,
  "<MySQL_SUBDATE />": MySQL_SUBDATE,
  "<MySQL_SUBSTR />": MySQL_SUBSTR,
  "<MySQL_SUBSTRING />": MySQL_SUBSTRING,
  "<MySQL_SUBSTRING_INDEX />": MySQL_SUBSTRING_INDEX,
  "<MySQL_SUBTIME />": MySQL_SUBTIME,
  "<MySQL_SUM />": MySQL_SUM,
  "<MySQL_SYSDATE />": MySQL_SYSDATE,
  "<MySQL_SYSTEM_USER />": MySQL_SYSTEM_USER,
  "<MySQL_TAN />": MySQL_TAN,
  "<MySQL_TIME />": MySQL_TIME,
  "<MySQL_TIMEDIFF />": MySQL_TIMEDIFF,
  "<MySQL_TIMESTAMP />": MySQL_TIMESTAMP,
  "<MySQL_TIME_FORMAT />": MySQL_TIME_FORMAT,
  "<MySQL_TIME_TO_SEC />": MySQL_TIME_TO_SEC,
  "<MySQL_TO_DAYS />": MySQL_TO_DAYS,
  "<MySQL_TRIM />": MySQL_TRIM,
  "<MySQL_TRUNCATE />": MySQL_TRUNCATE,
  "<MySQL_UCASE />": MySQL_UCASE,
  "<MySQL_UPPER />": MySQL_UPPER,
  "<MySQL_USER />": MySQL_USER,
  "<MySQL_VERSION />": MySQL_VERSION,
  "<MySQL_WEEK />": MySQL_WEEK,
  "<MySQL_WEEKDAY />": MySQL_WEEKDAY,
  "<MySQL_WEEKOFYEAR />": MySQL_WEEKOFYEAR,
  "<MySQL_YEAR />": MySQL_YEAR,
  "<MySQL_YEARWEEK />": MySQL_YEARWEEK,
  "<SQLServer_ABS />": SQLServer_ABS,
  "<SQLServer_ACOS />": SQLServer_ACOS,
  "<SQLServer_ASCII />": SQLServer_ASCII,
  "<SQLServer_ASIN />": SQLServer_ASIN,
  "<SQLServer_ATAN />": SQLServer_ATAN,
  "<SQLServer_ATN2 />": SQLServer_ATN2,
  "<SQLServer_AVG />": SQLServer_AVG,
  "<SQLServer_CAST />": SQLServer_CAST,
  "<SQLServer_CEILING />": SQLServer_CEILING,
  "<SQLServer_CHAR />": SQLServer_CHAR,
  "<SQLServer_CHARINDEX />": SQLServer_CHARINDEX,
  "<SQLServer_COALESCE />": SQLServer_COALESCE,
  "<SQLServer_CONCAT />": SQLServer_CONCAT,
  "<SQLServer_CONCAT_PLUS />": SQLServer_CONCAT_PLUS,
  "<SQLServer_CONCAT_WS />": SQLServer_CONCAT_WS,
  "<SQLServer_CONVERT />": SQLServer_CONVERT,
  "<SQLServer_COS />": SQLServer_COS,
  "<SQLServer_COT />": SQLServer_COT,
  "<SQLServer_COUNT />": SQLServer_COUNT,
  "<SQLServer_CURRENT_TIMESTAMP />": SQLServer_CURRENT_TIMESTAMP,
  "<SQLServer_CURRENT_USER />": SQLServer_CURRENT_USER,
  "<SQLServer_DATALENGTH />": SQLServer_DATALENGTH,
  "<SQLServer_DATEADD />": SQLServer_DATEADD,
  "<SQLServer_DATEDIFF />": SQLServer_DATEDIFF,
  "<SQLServer_DATEFROMPARTS />": SQLServer_DATEFROMPARTS,
  "<SQLServer_DATENAME />": SQLServer_DATENAME,
  "<SQLServer_DATEPART />": SQLServer_DATEPART,
  "<SQLServer_DAY />": SQLServer_DAY,
  "<SQLServer_DEGREES />": SQLServer_DEGREES,
  "<SQLServer_DIFFERENCE />": SQLServer_DIFFERENCE,
  "<SQLServer_EXP />": SQLServer_EXP,
  "<SQLServer_FLOOR />": SQLServer_FLOOR,
  "<SQLServer_FORMAT />": SQLServer_FORMAT,
  "<SQLServer_GETDATE />": SQLServer_GETDATE,
  "<SQLServer_GETUTCDATE />": SQLServer_GETUTCDATE,
  "<SQLServer_IIF />": SQLServer_IIF,
  "<SQLServer_ISDATE />": SQLServer_ISDATE,
  "<SQLServer_ISNULL />": SQLServer_ISNULL,
  "<SQLServer_ISNUMERIC />": SQLServer_ISNUMERIC,
  "<SQLServer_LEFT />": SQLServer_LEFT,
  "<SQLServer_LEN />": SQLServer_LEN,
  "<SQLServer_LOG />": SQLServer_LOG,
  "<SQLServer_LOG10 />": SQLServer_LOG10,
  "<SQLServer_LOWER />": SQLServer_LOWER,
  "<SQLServer_LTRIM />": SQLServer_LTRIM,
  "<SQLServer_MAX />": SQLServer_MAX,
  "<SQLServer_MIN />": SQLServer_MIN,
  "<SQLServer_MONTH />": SQLServer_MONTH,
  "<SQLServer_NCHAR />": SQLServer_NCHAR,
  "<SQLServer_NULLIF />": SQLServer_NULLIF,
  "<SQLServer_PATINDEX />": SQLServer_PATINDEX,
  "<SQLServer_PI />": SQLServer_PI,
  "<SQLServer_POWER />": SQLServer_POWER,
  "<SQLServer_QUOTENAME />": SQLServer_QUOTENAME,
  "<SQLServer_RADIANS />": SQLServer_RADIANS,
  "<SQLServer_RAND />": SQLServer_RAND,
  "<SQLServer_REPLACE />": SQLServer_REPLACE,
  "<SQLServer_REPLICATE />": SQLServer_REPLICATE,
  "<SQLServer_REVERSE />": SQLServer_REVERSE,
  "<SQLServer_RIGHT />": SQLServer_RIGHT,
  "<SQLServer_ROUND />": SQLServer_ROUND,
  "<SQLServer_RTRIM />": SQLServer_RTRIM,
  "<SQLServer_SESSIONPROPERTY />": SQLServer_SESSIONPROPERTY,
  "<SQLServer_SESSION_USER />": SQLServer_SESSION_USER,
  "<SQLServer_SIGN />": SQLServer_SIGN,
  "<SQLs_Alter_Table />": SQLs_Alter_Table,
  "<SQLs_And />": SQLs_And,
  "<SQLs_Auto_Increment />": SQLs_Auto_Increment,
  "<SQLs_Backup_DB />": SQLs_Backup_DB,
  "<SQLs_Between />": SQLs_Between,
  "<SQLs_Case />": SQLs_Case,
  "<SQLs_Check />": SQLs_Check,
  "<SQLs_Constraints />": SQLs_Constraints,
  "<SQLs_Create_DB />": SQLs_Create_DB,
  "<SQLs_Create_Table />": SQLs_Create_Table,
  "<SQLs_Data_Types />": SQLs_Data_Types,
  "<SQLs_Dates />": SQLs_Dates,
  "<SQLs_Default />": SQLs_Default,
  "<SQLs_Delete />": SQLs_Delete,
  "<SQLs_Drop_DB />": SQLs_Drop_DB,
  "<SQLs_Drop_Table />": SQLs_Drop_Table,
  "<SQLs_Exists />": SQLs_Exists,
  "<SQLs_Foreign_Key />": SQLs_Foreign_Key,
  "<SQLs_Group_By />": SQLs_Group_By,
  "<SQLs_Having />": SQLs_Having,
  "<SQLs_Hosting />": SQLs_Hosting,
  "<SQLs_In />": SQLs_In,
  "<SQLs_Index />": SQLs_Index,
  "<SQLs_Injection />": SQLs_Injection,
  "<SQLs_Inner_Join />": SQLs_Inner_Join,
  "<SQLs_Insert_Into_Select />": SQLs_Insert_Into_Select,
  "<SQLs_Joins />": SQLs_Joins,
  "<SQLs_Left_Join />": SQLs_Left_Join,
  "<SQLs_Like />": SQLs_Like,
  "<SQLs_Not />": SQLs_Not,
  "<SQLs_Not_Null />": SQLs_Not_Null,
  "<SQLs_Or />": SQLs_Or,
  "<SQLs_Primary_Key />": SQLs_Primary_Key,
  "<SQLs_Right_Join />": SQLs_Right_Join,
  "<SQLs_Select_Into />": SQLs_Select_Into,
  "<SQLs_Select_Top />": SQLs_Select_Top,
  "<SQLs_Union />": SQLs_Union,
  "<SQLs_Union_All />": SQLs_Union_All,
  "<SQLs_Unique />": SQLs_Unique,
  "<SQLs_Update />": SQLs_Update,
  "<SQLs_Views />": SQLs_Views,
  "<SQLs_Where />": SQLs_Where,
  "<SQLServer_SIN />": SQLServer_SIN,
  "<SQLServer_SOUNDEX />": SQLServer_SOUNDEX,
  "<SQLServer_SPACE />": SQLServer_SPACE,
  "<SQLServer_SQRT />": SQLServer_SQRT,
  "<SQLServer_SQUARE />": SQLServer_SQUARE,
  "<SQLServer_STR />": SQLServer_STR,
  "<SQLServer_STUFF />": SQLServer_STUFF,
  "<SQLServer_SUBSTRING />": SQLServer_SUBSTRING,
  "<SQLServer_SUM />": SQLServer_SUM,
  "<SQLServer_SYSDATETIME />": SQLServer_SYSDATETIME,
  "<SQLServer_SYSTEM_USER />": SQLServer_SYSTEM_USER,
  "<SQLServer_TAN />": SQLServer_TAN,
  "<SQLServer_TRANSLATE />": SQLServer_TRANSLATE,
  "<SQLServer_TRIM />": SQLServer_TRIM,
  "<SQLServer_UNICODE />": SQLServer_UNICODE,
  "<SQLServer_UPPER />": SQLServer_UPPER,
  "<SQLServer_USER_NAME />": SQLServer_USER_NAME,
  "<SQLServer_YEAR />": SQLServer_YEAR,
  "<SQL_ADD />": SQL_ADD,
  "<SQL_ADD_CONSTRAINT />": SQL_ADD_CONSTRAINT,
  "<SQL_Aggregate_Functions />": SQL_Aggregate_Functions,
  "<SQL_Aliases />": SQL_Aliases,
  "<SQL_ALL />": SQL_ALL,
  "<SQL_ALTER />": SQL_ALTER,
  "<SQL_ALTER_COLUMN />": SQL_ALTER_COLUMN,
  "<SQL_ALTER_TABLE />": SQL_ALTER_TABLE,
  "<SQL_AND />": SQL_AND,
  "<SQL_ANY />": SQL_ANY,
  "<SQL_Any_All />": SQL_Any_All,
  "<SQL_AS />": SQL_AS,
  "<SQL_ASC />": SQL_ASC,
  "<SQL_Auto_Increment />": SQL_Auto_Increment,
  "<SQL_Avg />": SQL_Avg,
  "<SQL_BACKUP_DATABASE />": SQL_BACKUP_DATABASE,
  "<SQL_Backup_DB />": SQL_Backup_DB,
  "<SQL_BETWEEN />": SQL_BETWEEN,
  "<SQL_Bootcamp />": SQL_Bootcamp,
  "<SQL_CASE />": SQL_CASE,
  "<SQL_Certificate />": SQL_Certificate,
  "<SQL_CHECK />": SQL_CHECK,
  "<SQL_COLUMN />": SQL_COLUMN,
  "<SQL_Comments />": SQL_Comments,
  "<SQL_CONSTRAINT />": SQL_CONSTRAINT,
  "<SQL_Constraints />": SQL_Constraints,
  "<SQL_Count />": SQL_Count,
  "<SQL_CREATE />": SQL_CREATE,
  "<SQL_CREATE_DATABASE />": SQL_CREATE_DATABASE,
  "<SQL_Create_DB />": SQL_Create_DB,
  "<SQL_CREATE_INDEX />": SQL_CREATE_INDEX,
  "<SQL_CREATE_OR_REPLACE_VIEW />": SQL_CREATE_OR_REPLACE_VIEW,
  "<SQL_CREATE_PROCEDURE />": SQL_CREATE_PROCEDURE,
  "<SQL_CREATE_TABLE />": SQL_CREATE_TABLE,
  "<SQL_CREATE_UNIQUE_INDEX />": SQL_CREATE_UNIQUE_INDEX,
  "<SQL_CREATE_VIEW />": SQL_CREATE_VIEW,
  "<SQL_DATABASE />": SQL_DATABASE,
  "<SQL_Data_Types />": SQL_Data_Types,
  "<SQL_Dates />": SQL_Dates,
  "<SQL_DEFAULT />": SQL_DEFAULT,
  "<SQL_DELETE />": SQL_DELETE,
  "<SQL_DESC />": SQL_DESC,
  "<SQL_DISTINCT />": SQL_DISTINCT,
  "<SQL_DROP />": SQL_DROP,
  "<SQL_DROP_COLUMN />": SQL_DROP_COLUMN,
  "<SQL_DROP_CONSTRAINT />": SQL_DROP_CONSTRAINT,
  "<SQL_DROP_DATABASE />": SQL_DROP_DATABASE,
  "<SQL_Drop_DB />": SQL_Drop_DB,
  "<SQL_DROP_DEFAULT />": SQL_DROP_DEFAULT,
  "<SQL_DROP_INDEX />": SQL_DROP_INDEX,
  "<SQL_DROP_TABLE />": SQL_DROP_TABLE,
  "<SQL_DROP_VIEW />": SQL_DROP_VIEW,
  "<SQL_Editor />": SQL_Editor,
  "<SQL_Examples />": SQL_Examples,
  "<SQL_EXEC />": SQL_EXEC,
  "<SQL_Exercises />": SQL_Exercises,
  "<SQL_EXISTS />": SQL_EXISTS,
  "<SQL_FOREIGN_KEY />": SQL_FOREIGN_KEY,
  "<SQL_FROM />": SQL_FROM,
  "<SQL_Full_Join />": SQL_Full_Join,
  "<SQL_FULL_OUTER_JOIN />": SQL_FULL_OUTER_JOIN,
  "<SQL_GROUP_BY />": SQL_GROUP_BY,
  "<SQL_HAVING />": SQL_HAVING,
  "<SQL_Home />": SQL_Home,
  "<SQL_Hosting />": SQL_Hosting,
  "<SQL_IN />": SQL_IN,
  "<SQL_INDEX />": SQL_INDEX,
  "<SQL_Injection />": SQL_Injection,
  "<SQL_INNER_JOIN />": SQL_INNER_JOIN,
  "<SQL_INSERT_INTO />": SQL_INSERT_INTO,
  "<SQL_INSERT_INTO_SELECT />": SQL_INSERT_INTO_SELECT,
  "<SQL_Intro />": SQL_Intro,
  "<SQL_IS_NOT_NULL />": SQL_IS_NOT_NULL,
  "<SQL_IS_NULL />": SQL_IS_NULL,
  "<SQL_JOIN />": SQL_JOIN,
  "<SQL_Joins />": SQL_Joins,
  "<SQL_LEFT_JOIN />": SQL_LEFT_JOIN,
  "<SQL_LIKE />": SQL_LIKE,
  "<SQL_LIMIT />": SQL_LIMIT,
  "<SQL_Min_Max />": SQL_Min_Max,
  "<SQL_NOT />": SQL_NOT,
  "<SQL_NOT_NULL />": SQL_NOT_NULL,
  "<SQL_Null_Functions />": SQL_Null_Functions,
  "<SQL_Null_Values />": SQL_Null_Values,
  "<SQL_Operators />": SQL_Operators,
  "<SQL_OR />": SQL_OR,
  "<SQL_ORDER_BY />": SQL_ORDER_BY,
  "<SQL_OUTER_JOIN />": SQL_OUTER_JOIN,
  "<SQL_PRIMARY_KEY />": SQL_PRIMARY_KEY,
  "<SQL_PROCEDURE />": SQL_PROCEDURE,
  "<SQL_Quick_Ref />": SQL_Quick_Ref,
  "<SQL_Quiz />": SQL_Quiz,
  "<SQL_RIGHT_JOIN />": SQL_RIGHT_JOIN,
  "<SQL_ROWNUM />": SQL_ROWNUM,
  "<SQL_SELECT />": SQL_SELECT,
  "<SQL_Selects />": SQL_Selects,
  "<SQL_Selects_Distinct />": SQL_Selects_Distinct,
  "<SQL_SELECT_DISTINCT />": SQL_SELECT_DISTINCT,
  "<SQL_SELECT_INTO />": SQL_SELECT_INTO,
  "<SQL_SELECT_TOP />": SQL_SELECT_TOP,
  "<SQL_Self_Join />": SQL_Self_Join,
  "<SQL_Server />": SQL_Server,
  "<SQL_Server_Functions />": SQL_Server_Functions,
  "<SQL_SET />": SQL_SET,
  "<SQL_Stored_Procedures />": SQL_Stored_Procedures,
  "<SQL_Study_Plan />": SQL_Study_Plan,
  "<SQL_Sum />": SQL_Sum,
  "<SQL_Syllabus />": SQL_Syllabus,
  "<SQL_Syntax />": SQL_Syntax,
  "<SQL_TABLE />": SQL_TABLE,
  "<SQL_TOP />": SQL_TOP,
  "<SQL_Training />": SQL_Training,
  "<SQL_TRUNCATE_TABLE />": SQL_TRUNCATE_TABLE,
  "<SQL_UNION />": SQL_UNION,
  "<SQL_UNION_ALL />": SQL_UNION_ALL,
  "<SQL_UNIQUE />": SQL_UNIQUE,
  "<SQL_UPDATE />": SQL_UPDATE,
  "<SQL_VALUES />": SQL_VALUES,
  "<SQL_VIEW />": SQL_VIEW,
  "<SQL_Views />": SQL_Views,
  "<SQL_WHERE />": SQL_WHERE,
  "<SQL_Wildcards />": SQL_Wildcards,
};

export default SQLComponentsMap;
